const DEFAULT_INSTATUS_SUMMARY_URL = "https://status.rebuild.work/summary.json";
const DEFAULT_INSTATUS_POLL_INTERVAL_MS = 60_000;

function parsePollInterval(value: string | undefined): number {
  const interval = Number(value);
  return Number.isFinite(interval) && interval > 0 ? interval : DEFAULT_INSTATUS_POLL_INTERVAL_MS;
}

export const instatusConfig = {
  summaryUrl: import.meta.env.VITE_INSTATUS_SUMMARY_URL || DEFAULT_INSTATUS_SUMMARY_URL,
  pollIntervalMs: parsePollInterval(import.meta.env.VITE_INSTATUS_POLL_INTERVAL_MS),
};
